import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import '../GridStyleOverrides/materialTableHome.css'
import { ConfirmDialog, WarnDialog } from "../../components/shared";
import { Typography } from "../../components/controls";
import 'date-fns';
import { Backdrop, Box, Button, Card, CardContent, CircularProgress, Container, Grid, Paper, TextField, Badge } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import { red, green } from '@material-ui/core/colors';
import _ from 'lodash';
import { BiDropdownService, BiPlanningService, BiDashboardService } from "../../services";
import { toStringDateTimeSecond, toStringDateTime } from './../../helpers/date';
import { SET_PLAN_DASHBOARD_DATA, SET_PLAN_DASHBOARD_SEARCH, SET_PLAN_DATA_ROW } from '../../actions/types';

export default function PlanDashboard(props) {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();

    // Loading
    const [isLoading, setIsLoading] = useState(true);

    const dashboardData = { ...useSelector((state) => state.planManagement.dashboardData) };
    const dashboardSearch = { ...useSelector((state) => state.planManagement.dashboardSearch) };
    const [formData, setFormData] = useState(dashboardData);
    const [searchData, setSearchData] = useState(dashboardSearch);
    const [time, setTime] = useState(new Date())
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const [warnDialog, setWarnDialog] = useState({ isOpen: false, title: '', subTitle: '' });

    //dropdown
    const [ddlPlant, setDdlPlant] = useState([]);
    const [ddlProduct, setDdlProduct] = useState([]);
    const [ddlArea, setDdlArea] = useState([]);
    const [ddlPoint, setDdlPoint] = useState([]);

    useEffect(() => plantLoad(), []);
    useEffect(() => {
        const intervalId = setInterval(() => { setTime(new Date()) }, 1000/* 1 second */);
        return () => clearInterval(intervalId);
    }, []);
    useEffect(() => {
        const intervalId = setInterval(() => { setFormData((v) => { return { ...v, hasChange: true }; }) }, 300000/* 5 minutes */);
        return () => clearInterval(intervalId);
    }, []);
    useEffect(() => {
        loadDashboard()
    }, [formData]);
    useEffect(() => {
        let plant = formData.plant ?? searchData.plant?.value ?? (ddlPlant.length > 0 ? ddlPlant[0].value : null)
        plantChange(plant)
        setFormData({ ...formData, time: time, plant: plant, hasChange: true })
    }, [ddlPlant]);
    useEffect(() => {
        areaChange(searchData.plant?.value, searchData.area?.value)
    }, [ddlArea]);

    const plantLoad = () => {
        setIsLoading(true);
        BiDropdownService.getPlant().then(r => {
            setDdlPlant(r)
        })
        setIsLoading(false);
    }
    const plantChange = (plant) => {
        if (plant) {
            BiDropdownService.getProduct(plant).then(r => {
                setDdlProduct(r)
            })
            BiDropdownService.getArea(plant).then(r => {
                setDdlArea(r)
            })
        } else {
            setDdlProduct([])
            setDdlArea([])
            setDdlPoint([])
        }
    }
    const areaChange = (plant, area) => {
        setIsLoading(true);
        if (plant && area) {
            BiDropdownService.getPoint(plant, area).then(r => {
                setDdlPoint(r)
            })
        } else {
            setDdlPoint([])
        }
        setIsLoading(false);
    }
    const setDispatchPlan = () => {
        dispatch({
            type: SET_PLAN_DASHBOARD_DATA,
            payload: { ...formData },
        });
        dispatch({
            type: SET_PLAN_DASHBOARD_SEARCH,
            payload: { ...searchData },
        });
    }
    const handleSearchFormChange = (target, fieldName) => {
        setSearchData({ ...searchData, [fieldName]: target })
        if (fieldName === 'plant')
            plantChange(target?.value)
        if (fieldName === 'area')
            areaChange(target?.value)
        setDispatchPlan()
    }
    const handleSearchSubmit = () => {
        setIsLoading(true);
        setFormData({ ...formData, time: time, plant: searchData.plant?.value, product: searchData.product?.value, area: searchData.area?.value, point: searchData.point?.value, hasChange: true })
    };
    const loadDashboard = () => {
        if (formData.hasChange === true) {
            BiDashboardService.getList(formData.plant, formData.product, formData.area, formData.point).then(r => {
                setFormData({ ...formData, time: time, items: r, hasChange: false })
                setDispatchPlan()
            })
        }
        setIsLoading(false);
    }
    const handleOpenTicket = (planId, ticketId) => {
        console.log(planId)
        setConfirmDialog({
            isOpen: true,
            title: `Confirm`,
            subTitle: <><Box component="div">{`Are you sure you want to open ticket ${ticketId} ?`}</Box></>,
            onConfirm: async () => {
                BiPlanningService.getPlanDetail(planId).then(r => {
                    if (r) {
                        setDispatchPlan()
                        dispatch({
                            type: SET_PLAN_DATA_ROW,
                            payload: { ...r, backTo: 'dashboard' },
                        });
                        history.push('/planning/plan-management/create');
                    } else {
                        setConfirmDialog({ ...confirmDialog, isOpen: false })
                        setWarnDialog({
                            isOpen: true,
                            title: `Error`,
                            subTitle: <><Box component="div">Can't open ticket {ticketId}</Box></>,
                        })
                    }
                })
            }
        })
    }
    const getColorItem = (data) => {
        if (data.state === 'FINISHED') {
            if (data.status === 'COMPLETED')
                return { backgroundColor: 'forestgreen' }
            if (data.status === 'CANCELED')
                return { backgroundColor: 'firebrick' }
        }
        if (data.state === 'PROCESS') {
            if (data.status === 'WAIT')
                return { backgroundColor: 'antiquewhite' }
            //itas
            switch (data.status) {
                case 'Waiting':
                    return { backgroundColor: 'wheat' }
                case 'Finished':
                    return { backgroundColor: 'darkgoldenrod' }
                case 'Cancel':
                    return { backgroundColor: 'plum' }
                case 'Weight in':
                case 'Loading':
                case 'Weight out':
                default:
                    return { backgroundColor: 'aquamarine' }
            }
        }
        if (data.state === 'PREPARE')
            return { backgroundColor: 'azure' }
        if (data.state === 'QUEUE') {
            if (data.status === 'TIMEOUT' || data.status === 'REJECTED')
                return { backgroundColor: 'slategray' }
            if (data.status === 'CHECK-IN')
                return { backgroundColor: 'cornflowerblue' }
            if (data.status === 'CALL' || data.status === 'RE-CALL')
                return { backgroundColor: 'chartreuse' }
            if (data.status === 'CONFIRMED' || data.status === 'HOLD')
                return { backgroundColor: 'cyan' }
            if (data.status === 'PENDING' || data.status === 'CHECK-OUT') {
                let b = data.bookTime ? new Date(data.bookTime) : null;
                let q = data.queueTime ? new Date(data.queueTime) : null;
                if (b && q && b < q)
                    return { backgroundColor: 'lightpink' }//over time
                if (b && q && b > q)
                    return { backgroundColor: 'deepskyblue' }//ahead time
                return { backgroundColor: 'cadetblue' }//on time
            }
        }
        return { backgroundColor: 'red' }//others
    }
    const getColorBadge = (data) => {
        if (data.state === 'QUEUE' && (data.status !== 'TIMEOUT' || data.status !== 'REJECTED')) {
            let b = data.bookTime ? new Date(data.bookTime) : null;
            let q = data.queueTime ? new Date(data.queueTime) : null;
            if (b && q && b < q)
                return 'error'//over time
            if (b && q && b > q)
                return 'primary'//ahead time
        }
        return 'secondary'//on time & others
    }

    return (
        <>
            <Container id='containerMR'>
                <div className={classes.pageTitleDiv}>
                    <h2 className={classes.pageTitle}>
                        QUEUE DASHBOARD
                    </h2>
                </div>
                <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    <Card className={classes.root}>
                        <CardContent>
                            <form>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={6} md={2} lg={2}>
                                                <TextField
                                                    label="Time"
                                                    disabled={true}
                                                    fullWidth
                                                    value={toStringDateTimeSecond(time)}
                                                    id="po"
                                                    name="po"
                                                    size="small"
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2} lg={2}>
                                                <Autocomplete
                                                    id="searchPlantList"
                                                    name="searchPlantList"
                                                    options={ddlPlant}
                                                    closeIcon={false}
                                                    value={searchData.plant ?? (ddlPlant && ddlPlant.length > 0 ? ddlPlant[0] : null)}
                                                    getOptionLabel={(option) => option?.text}
                                                    renderOption={option => <>{option?.text}</>}
                                                    onChange={(event, newValue) => handleSearchFormChange(newValue, 'plant')}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchPlantList"
                                                        name="searchPlantList"
                                                        label="Plant"
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2} lg={2}>
                                                <Autocomplete
                                                    id="searchProductList"
                                                    name="searchProductList"
                                                    options={ddlProduct}
                                                    value={searchData.product}
                                                    getOptionLabel={(option) => option?.text}
                                                    renderOption={option => <>{option?.text}</>}
                                                    onChange={(event, newValue) => handleSearchFormChange(newValue, 'product')}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchProductList"
                                                        name="searchProductList"
                                                        label="Product"
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2} lg={2}>
                                                <Autocomplete
                                                    id="searchAreaList"
                                                    name="searchAreaList"
                                                    options={ddlArea}
                                                    value={searchData.area}
                                                    getOptionLabel={(option) => option?.text}
                                                    getOptionSelected={(option, value) => option?.text === value?.text}
                                                    getOptionDisabled={(option) => option?.value === ""}
                                                    renderOption={option => <>{option?.text}</>}
                                                    onChange={(event, newValue) => handleSearchFormChange(newValue, 'area')}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchAreaList"
                                                        name="searchAreaList"
                                                        label="Area"
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2} lg={2}>
                                                <Autocomplete
                                                    id="searchPointList"
                                                    name="searchPointList"
                                                    options={ddlPoint}
                                                    value={searchData.point}
                                                    getOptionLabel={(option) => option?.text}
                                                    renderOption={option => <>{option?.text}</>}
                                                    onChange={(event, newValue) => handleSearchFormChange(newValue, 'point')}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchPointList"
                                                        name="searchPointList"
                                                        label="Point"
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2} lg={2}>
                                                <Button style={{ width: '100%' }} variant="contained" color="primary" onClick={handleSearchSubmit}>Generate</Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </Grid>
            </Container >
            <Container >
                <Box py={2}>
                    <Grid container justify="left" alignItems="left" spacing={1}>
                        <Card className={classes.root} style={{ width: '100%' }}>
                            <Box component="hr" fullWidth></Box>
                            {formData.items?.map((item) => {
                                let countFinished = 0;
                                return (<>
                                    <CardContent>
                                        <Grid container spacing={2}>
                                            <Grid item>
                                                <Paper style={{ height: 150, width: 250, padding: 5, marginRight: 10, textAlign: "center", display: 'inline-grid', boxShadow: 'none', backgroundColor: 'unset' }}
                                                    elevation={3} direction="column" justifyContent="center">
                                                    <Typography variant="h5" component="h3" style={{ color: 'blue' }}>
                                                        {item.plant}
                                                    </Typography>
                                                    <Typography component="p">
                                                        {item.area}
                                                    </Typography>
                                                    <Typography component="p">
                                                        {item.point}
                                                    </Typography>
                                                </Paper>
                                            </Grid>
                                            {item.list.map((child, index) => {
                                                if (child.state === 'FINISHED')
                                                    countFinished++;
                                                return (<>
                                                    <Grid item>
                                                        <Badge badgeContent={child.state === 'FINISHED' ? 0 : (index + 1 - countFinished)} anchorOrigin={{ vertical: 'top', horizontal: 'left' }} color={getColorBadge(child)}>
                                                            <Paper style={{ ...getColorItem(child), height: 150, width: 250, padding: 5, marginRight: 10, textAlign: "center", display: 'inline-grid' }}
                                                                elevation={3} direction="column" justifyContent="center" onDoubleClick={() => handleOpenTicket(child.planId, child.ticketId)}>
                                                                <Typography component="p" onClick={() => handleOpenTicket(child.planId, child.ticketId)} style={{ cursor: 'pointer' }}>
                                                                    {child.ticketId}
                                                                </Typography>
                                                                <Typography component="p">
                                                                    ({child.status})
                                                                </Typography>
                                                                <Typography component="p">
                                                                    {child.product}
                                                                </Typography>
                                                                <Typography component="p">
                                                                    <b>{child.truckNo}</b>
                                                                </Typography>
                                                                <Typography component="p">
                                                                    <b>{toStringDateTime(child.queueTime)}</b>
                                                                </Typography>
                                                            </Paper>
                                                        </Badge>
                                                    </Grid>
                                                </>)
                                            })}
                                        </Grid>
                                    </CardContent>
                                    <Box component="hr" fullWidth></Box>
                                </>)
                            })}
                        </Card>
                    </Grid>
                </Box>
            </Container >
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
            <WarnDialog
                warnDialog={warnDialog}
                setWarnDialog={setWarnDialog}
            />
            <Backdrop className={classes.backdrop} open={isLoading} timeout={{ enter: 1100 }}>
                <CircularProgress color="inherit" />
            </Backdrop>

        </>
    );
}

const useStyles = makeStyles((theme) => ({
    gridActionsContainer: {
        display: 'flex',
        width: '100%',
        height: 32,
        alignItems: 'center',
        justifyContent: 'flex-end',
        backgroundColor: theme.palette.background.paper,
        borderTopRightRadius: 4,
        borderTopLeftRadius: 4
    },
    materialReceivingTable: {
        minWidth: 650,
        paddingLeft: 0,
        paddingRight: 0,
        '& .MuiDataGrid-colCellWrapper': {
            backgroundColor: '#86C1D4'
        },
        '& .material-receiving-table.error': {
            backgroundColor: red[100],
            color: red[600],
        },
        '& .material-receiving-table.success': {
            backgroundColor: green[100],
            color: green[600],
        },
        '& .material-receiving-table--header': {
            backgroundColor: '#86C1D4',
            color: 'white',
            fontWeight: 'bold',
        },
        '& svg.MuiSvgIcon-root.MuiDataGrid-iconSeparator': {
            display: 'none'
        }
    },
    table: {
        backgroundColor: theme.palette.background.paper,
    },
    addMaterialReceiving: {
        textAlign: 'center',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
    pageTitleDiv: {
        marginTop: 20,
    },
    pageTitle: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 0,
        fontSize: 18,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
}));